import { IconButton, Stack } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { TableCommunication } from '../TableCommunication';
import React, { useCallback, useState } from 'react';
import { useInjection } from './hook';
import { CommunicationUpdate, fileResCommunication, TDateCommunication } from '../../type';
import { Lead } from 'types/user';
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { deleteNote } from 'services/leads';
import { useFlash } from 'contexts/flash';
export type UpdateTabProps = {
  isUpdate?: boolean;
  initData: CommunicationUpdate;
  handleChangeDate: ({
    endDate,
    startDate
  }: {
    startDate?: string | null;
    endDate?: string | null;
  }) => void;
  dateSearch: TDateCommunication | null;
  handleCopyAllUpdates?: (fileInfo?: fileResCommunication) => void;
  handleDeleteAllNote?: (id: number) => void;
  title: string;
  dataClientSelected: fileResCommunication | undefined;
  setDataClientSelected: (value: fileResCommunication | undefined) => void;
};
export const UpdateTab = ({
  initData,
  isUpdate,
  handleChangeDate,
  dateSearch,
  handleCopyAllUpdates,
  handleDeleteAllNote,
  dataClientSelected,
  setDataClientSelected,
  title
}: UpdateTabProps) => {
  const { setFlash } = useFlash();
  const { dataRow, hasMore, fetchMoreData, setDataRow } = useInjection({ initData, dateSearch });
  const [isDeleteNote, setIdDeleteNote] = useState<number | null>(null);
  const [idFileDeleteNote, setIdFileDeleteNote] = React.useState<number | null>(null);
  const [leadDelete, setLeadDelete] = useState<Partial<Lead> | undefined>(undefined);

  const onDeleteNoteLead = useCallback(async () => {
    if (!isDeleteNote) return;
    await deleteNote(isDeleteNote);
    setIdDeleteNote(null);
    setLeadDelete(undefined);
    setFlash({
      message: 'Delete note successful',
      type: 'success'
    });
    if (!dataClientSelected?.id) return;
    setDataRow((prev) =>
      prev.map((item) => {
        if (Number(item.id) !== Number(dataClientSelected?.id)) return item;

        return {
          ...item,
          leads: item.leads.map((itemLead) => {
            if (Number(itemLead.id) !== Number(leadDelete?.id)) return itemLead;

            return {
              ...itemLead,
              notes: (itemLead.notes || []).filter(
                (note) => Number(note.id) !== Number(isDeleteNote)
              )
            };
          })
        };
      })
    );

    const newData: fileResCommunication = {
      ...dataClientSelected,
      leads:
        dataClientSelected?.leads?.map((itemLead) =>
          itemLead.id === leadDelete?.id
            ? {
                ...itemLead,
                notes: (itemLead.notes || []).filter(
                  (note) => Number(note.id) !== Number(isDeleteNote)
                )
              }
            : itemLead
        ) || []
    };
    setDataClientSelected(newData);
  }, [
    dataClientSelected,
    isDeleteNote,
    leadDelete?.id,
    setDataClientSelected,
    setDataRow,
    setFlash
  ]);
  const { asyncCallback: asyncOnDeleteLead } = useAsyncCallback(onDeleteNoteLead, []);
  return (
    <>
      <TableCommunication
        isUpdate={isUpdate}
        handleDeleteNote={(value) => {
          setLeadDelete(value.lead);
          setIdDeleteNote(value.idNote);
        }}
        dataClientSelected={dataClientSelected}
        setDataClientSelected={setDataClientSelected}
        headers={[
          { label: 'Updated By' },
          { label: 'Date' },
          { label: 'Lead ' },
          { label: 'Details' },
          {
            label: (
              <Stack flexDirection={'row'} gap={2}>
                <IconButton
                  onClick={() => {
                    if (!dataClientSelected) return;
                    handleCopyAllUpdates && handleCopyAllUpdates(dataClientSelected);
                  }}>
                  <ContentCopyOutlinedIcon />
                </IconButton>
                <IconButton
                  onClick={() => {
                    if (!dataClientSelected?.id) return;
                    setIdFileDeleteNote(dataClientSelected?.id);
                  }}>
                  <DeleteIcon />
                </IconButton>
              </Stack>
            )
          }
        ]}
        hasMore={hasMore}
        fetchMoreData={fetchMoreData}
        label={title}
        rows={dataRow}
        handleChangeDate={(startDate?: string | null, endDate?: string | null) => {
          handleChangeDate({ startDate, endDate });
        }}
        date={dateSearch}
      />
      {idFileDeleteNote && handleDeleteAllNote && (
        <DialogConfirm
          width={'450px'}
          isOpen={!!idFileDeleteNote}
          onClose={() => setIdFileDeleteNote(null)}
          onSubmit={() => {
            handleDeleteAllNote(idFileDeleteNote);
            setIdFileDeleteNote(null);
          }}
          textTitle={'Delete All Note'}
          textButton={'Delete'}
          textContent={'Are you sure you want to delete all notes?'}
        />
      )}
      <DialogConfirm
        width={'450px'}
        isOpen={!!isDeleteNote}
        onClose={() => setIdDeleteNote(null)}
        onSubmit={asyncOnDeleteLead}
        textTitle={'Delete Note'}
        textButton={'Delete'}
        textContent={'Are you sure delete note.'}
      />
    </>
  );
};
